import './item-search-screen.scss';

import { defineComponent } from 'vue';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SortFilter } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SearchFeaturedList, TitleClickAction } from '@skinsoft/ui';

import { SearchHeader } from '@skinsoft/search/src/search-header';

declare const config
const ITEM_SORTING_ENTITY_FIELDS: SortFilter[] = config.itemsSortingEntityFields
const OFFLINE_ITEM_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineItemsSortingEntityFields

export const ItemSearchScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchFeaturedList: SearchFeaturedList,
        sSearchHeader: SearchHeader
    },
    props: ['targetRouteName', 'creationTargetRouteName', 'canCreateObject', 'displayedButtons', 'onlyNewItems', 'titleClickAction'],
    template: require('./item-search-screen.html'),
    data() {
        return {
            sortingEntityFields: [] as any[],
            loadingItemCreation: false,
            spinnerIcon: faCircleNotch,
        }
    },
    mounted() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = ITEM_SORTING_ENTITY_FIELDS
        } else {
            this.sortingEntityFields = OFFLINE_ITEM_SORTING_ENTITY_FIELDS
        }

        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    },
    methods: {
        createNewItem() {
            this.loadingItemCreation = true
            if (window.navigator.onLine) {
                this.$itemDataStore.create({}, {}).subscribe(this.getToNewItem)
            } else {
                const currentInstitution: string = localStorage.getItem('institution') as string
                this.$itemDataStore.createOffline({
                    institutionCreation: currentInstitution
                }).subscribe(this.getToNewItem)

            }
        },
        getToNewItem(item: {id: string}) {
            const path = this.creationTargetRouteName ? this.creationTargetRouteName : this.targetRouteName
            this.$router.push({name: path, params: {itemId: item.id}, query: {imageChoice: 'true'}})
        },
        updateSortingFields() {
            if(window.navigator.onLine) {
                this.sortingEntityFields = ITEM_SORTING_ENTITY_FIELDS
            } else {
                this.sortingEntityFields = OFFLINE_ITEM_SORTING_ENTITY_FIELDS
            }
        },
    },
})
